import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { GlobalEvent } from '../../observe/globalnew.state';

@Injectable()
export class GlobalErrorInterceptor implements HttpInterceptor {
    constructor(private router: Router,
        private gl$: GlobalEvent
    ) {
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req).pipe(
            catchError((httpErrorResponse: HttpErrorResponse) => {

                if (httpErrorResponse.status === 401) {
                    localStorage.clear();

                    this.router.navigateByUrl('/auth/login').then(() => {
                        this.gl$.notifyDataChanged('CODE', '401');
                    });

                } else {

                    this.gl$.notifyDataChanged('CODE', '401');

                }
                return throwError(httpErrorResponse);
            })
        );
    }
}
